import { Injectable } from '@angular/core';
import { from, map } from 'rxjs';
import { assign, cloneDeep } from 'lodash-es';
import { FuseMockApiService, FuseMockApiUtils } from '@fuse/lib/mock-api';
import { subscriptions as subscriptionsData } from './data';


@Injectable({
    providedIn: 'root'
})
export class SubscriptionsMockApi
{
    private _subscriptions: any[] = subscriptionsData;

    /**
     * Constructor
     */
    constructor(private _fuseMockApiService: FuseMockApiService)
    {
        // Register Mock API handlers
        this.registerHandlers();
    }

    // -----------------------------------------------------------------------------------------------------
    // @ Public methods 
    // -----------------------------------------------------------------------------------------------------

    /**
     * Register Mock API handlers
     */
    registerHandlers(): void
    {
        // -----------------------------------------------------------------------------------------------------
        // @ Subscription - GET
        // -----------------------------------------------------------------------------------------------------
        this._fuseMockApiService
            .onGet('api/apps/subscriptions/all')
            .reply(() => {

                // Clone the subscriptions
                const subscriptions = cloneDeep(this._subscriptions);

                // Sort the subscriptions by the name field by default
                subscriptions.sort((a, b) => a.name.localeCompare(b.name));

                // Return the response
                return [200, subscriptions];
            });

        // -----------------------------------------------------------------------------------------------------
        // @ Subscription Search - GET
        // -----------------------------------------------------------------------------------------------------
        this._fuseMockApiService
            .onGet('api/apps/subscriptions/search')
            .reply(({request}) => {

                // Get the search query
                const query = request.params.get('query');

                // Clone the subscriptions
                let subscriptions = cloneDeep(this._subscriptions);

                // If the query exists...
                if ( query )
                {
                    // Filter the subscriptions
                    subscriptions = subscriptions.filter(subscription => subscription.name && subscription.name.toLowerCase().includes(query.toLowerCase()));
                }

                // Sort the subscriptions by the name field by default
                subscriptions.sort((a, b) => a.name.localeCompare(b.name));

                // Return the response
                return [200, subscriptions];
            });

        // -----------------------------------------------------------------------------------------------------
        // @ Contact - GET
        // -----------------------------------------------------------------------------------------------------
        this._fuseMockApiService
            .onGet('api/apps/subscriptions/subscription')
            .reply(({request}) => {

                // Get the id from the params
                const id = request.params.get('id');

                // Clone the subscriptions
                const subscriptions = cloneDeep(this._subscriptions);

                // Find the subscription
                const subscription = subscriptions.find(item => item.id === id);

                // Return the response
                return [200, subscription];
            });

        // -----------------------------------------------------------------------------------------------------
        // @ Contact - POST
        // -----------------------------------------------------------------------------------------------------
        this._fuseMockApiService
            .onPost('api/apps/subscriptions/subscription')
            .reply(() => {

                // Generate a new subscription
                const newContact = {
                    id          : FuseMockApiUtils.guid(),
                    avatar      : null,
                    name        : 'New Contact',
                    emails      : [],
                    phoneNumbers: [],
                    job         : {
                        title  : '',
                        company: ''
                    },
                    birthday    : null,
                    address     : null,
                    notes       : null,
                    tags        : []
                };

                // Unshift the new subscription
                this._subscriptions.unshift(newContact);

                // Return the response
                return [200, newContact];
            });

        // -----------------------------------------------------------------------------------------------------
        // @ Contact - PATCH
        // -----------------------------------------------------------------------------------------------------
        this._fuseMockApiService
            .onPatch('api/apps/subscriptions/subscription')
            .reply(({request}) => {

                // Get the id and subscription
                const id = request.body.id;
                const subscription = cloneDeep(request.body.subscription);

                // Prepare the updated subscription
                let updatedContact = null;

                // Find the subscription and update it
                this._subscriptions.forEach((item, index, subscriptions) => {

                    if ( item.id === id )
                    {
                        // Update the subscription
                        subscriptions[index] = assign({}, subscriptions[index], subscription);

                        // Store the updated subscription
                        updatedContact = subscriptions[index];
                    }
                });

                // Return the response
                return [200, updatedContact];
            });

        // -----------------------------------------------------------------------------------------------------
        // @ Contact - DELETE
        // -----------------------------------------------------------------------------------------------------
        this._fuseMockApiService
            .onDelete('api/apps/subscriptions/subscription')
            .reply(({request}) => {

                // Get the id
                const id = request.params.get('id');

                // Find the subscription and delete it
                this._subscriptions.forEach((item, index) => {

                    if ( item.id === id )
                    {
                        this._subscriptions.splice(index, 1);
                    }
                });

                // Return the response
                return [200, true];
            });
    }
}
